import type { FC } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type RewriteRouteProps = {
  path: string;
};

/**
 * Rewrites to a given url.
 * Useful where you want an alias to another path.
 */
const RewriteRoute: FC<RewriteRouteProps> = ({ path }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (path) {
      navigate(path, { replace: true });
    }
  }, [path, navigate]);

  return null;
};

export default RewriteRoute;
